import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/operadoras/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);

headers.append("content-type", "application/json");

export async function findOperadoras(empresa_cnpj) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
}

export async function findOperadorasPorBandeira(empresa_cnpj, idBandeira) {
  return search(
    `${path}/por-bandeira?idBandeira=${idBandeira}&empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}
